module.exports = __webpack_public_path__ + "static/media/eventRegistrationGraphic.8f46cfa6.svg";